import { default as BSCollapse } from 'bootstrap/js/dist/collapse';

// Класс Collapse от bootstrap
window.bootstrap.Collapse = BSCollapse;
